var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtDecimal = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M87.729 200.623h-23.59V104.35l-22.422.497V87.838l46.012-8.221zM149.35 200.623h-23.337v-21.44h23.338zM202.86 77.942q16.195 0 25.828 12.583 9.635 12.582 9.635 36.666l-.022 25.993q0 24.172-9.595 36.67-9.595 12.5-25.702 12.514-16.28 0-25.91-12.5t-9.617-36.684v-25.993q0-24.084 9.595-36.666c9.595-12.582 14.993-12.583 25.788-12.583m-8.8 25.824q-2.989 6.747-3.032 21.349v29.984q0 14.785 3.053 21.554t8.636 6.272h.523q5.482.496 8.47-6.228 2.987-6.726 2.992-21.594l.013-29.993q0-14.615-3.053-21.344t-8.553-6.311h-.497q-5.565-.435-8.553 6.31"
}))));
export default SvgQtDecimal;